import { ReactNode } from 'react'
import Image from 'next/image'
import closeIcon from '../../../public/close.png'

interface PopupModalProps {
  showModal: boolean
  closeModal: () => void
  children: ReactNode
}

const PopupModal = ({ showModal, closeModal, children }: PopupModalProps) => {
  if (!showModal) return null

  return (
    <div className="phone-popup-modal">
      <button
        className="phone-popup-modal-close"
        onClick={closeModal}
      >
        <Image src={closeIcon} alt="Close button" />
      </button>
      {children}
    </div>
  )
}
export default PopupModal
